import { ApolloClient } from '@apollo/client';

export const removeBookmarkFromCache = (
  removedBookmarkId: string,
  client: ApolloClient<object>
) => {
  client.cache.modify({
    fields: {
      bookmarks(existing, { readField }) {
        return existing.filter(
          item => readField('id', item.item) !== removedBookmarkId
        );
      }
    },
    broadcast: true
  });
};
